import { Component, input, computed } from '@angular/core';

import { TApiErrorResponse } from '../../http';

@Component({
  standalone: true,
  imports: [],
  selector: 'lib-error-alert',
  template: `
    @if (error()) {
    <div class="flex">
      <div class="flex-shrink-0">
        <svg
          class="h-5 w-5 text-red-400"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-medium text-red-800">
          {{ capitalizedMessage() }}
        </h3>
        @if (hasDetails()) {
        <ul class="list-disc list-inside text-red-800 text-sm">
          @for (detail of details(); track detail) {
          <li>{{ detail }}</li>
          }
        </ul>
        }
      </div>
    </div>
    }
  `,
})
export class ErrorAlertComponent {
  /**
   * Error message to display in the alert
   */
  error = input<TApiErrorResponse | string | null>(null);

  hasDetails = computed(() => {
    const error = this.error();
    if (!error || typeof error === 'string') return false;

    return (error.details?.length ?? 0) > 0;
  });

  details = computed(() => {
    const error = this.error();
    if (!error || typeof error === 'string') return [];
    return error.details ?? [];
  });

  /**
   * Computed property that capitalizes the first character of the message
   */
  capitalizedMessage = computed(() => {
    const error = this.error();

    if (!error) {
      return '';
    }

    if (typeof error === 'string') {
      const firstChar = error.charAt(0).toUpperCase();
      const rest = error.slice(1);
      return firstChar + rest;
    }

    if (
      error &&
      typeof error === 'object' &&
      'message' in error &&
      error.message
    ) {
      const message = error.message;
      return message.charAt(0).toUpperCase() + message.slice(1);
    }

    return '';
  });
}
